
import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const CustomUploader = () => {
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    setFiles(acceptedFiles);
  }, []);

//   const onDrop = useCallback((acceptedFiles) => {
//     setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
//   }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true, // accept multiple files
  });

  return (
    <div style={styles.container}>
      {/* Header */}
      {/* <div style={styles.header}>
        <span style={styles.title}>Download Lost/Damaged Asset Report Form</span>
        <button style={styles.downloadBtn}>Download Report</button>
      </div> */}

      {/* Drop Area */}
      <div {...getRootProps()} style={styles.dropArea}>
        <input {...getInputProps()} />
        {
          isDragActive
            ? <p style={styles.dropText}>Drop your file here...</p>
            : <p style={styles.dropText}>Upload Your Report Here.</p>
        }
      </div>

      {/* Uploaded Files */}
      {files.length > 0 && (
        <ul style={styles.fileList}>
          {files.map((file, index) => (
            <li key={index} style={styles.fileItem}>{file.name}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

const styles = {
  container: {
    background: "transparent",
    borderRadius: '16px',
    padding: '20px 0',
    width: '100%',
    color: '#fff',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '15px',
    alignItems: 'center',
    backgroundColor: '#ffffff08',
    padding: '10px',
    borderRadius: "12px"
  },
  title: {
    fontSize: '14px',
    fontWeight: '500',
  },
  downloadBtn: {
    background: 'linear-gradient(to right, #8660f8, #ded3ff)',
    border: 'none',
    padding: '6px 14px',
    borderRadius: '8px',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  dropArea: {
    border: '2px dashed #555',
    borderRadius: '12px',
    padding: '60px',
    textAlign: 'center',
    backgroundColor: '#ffffff08',
  },
  dropText: {
    color: '#aaa',
    fontSize: '14px',
  },
  fileList: {
    marginTop: '16px',
    padding: 0,
    listStyle: 'none',
  },
  fileItem: {
    fontSize: '13px',
    padding: '4px 0',
    borderBottom: '1px solid #333',
  },
};

export default CustomUploader;
